<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- logo -->
    <logo_display :target_url="'https://foreverliving.com/hkg/zh-hk/home'" />
    <!-- logo -->

    <!-- heading -->
    <page_banner page_title="資源下載" />
    <!-- heading -->

    <!-- content -->
    <div style="flex: 1">
      <b-container class="mb-5 mt-5 p3">
        <source_tree
          v-for="(category, index) in categorys"
          :key="index"
          :category="category"
          :index="index"
        />
      </b-container>
    </div>
    <!-- content -->

    <footer_page />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";
import footer_page from "./footer_page.vue";
import source_tree from "./source_tree.vue";
import api from "@/api";

const categorys = ref([]);

onMounted(async () => {
  categorys.value = [];
  let categorys_response = await api.get("/api/get_source");
  categorys.value = categorys_response.data;
  console.log(categorys_response.data);
});
</script>
